import React from 'react';
import { GET_ACTIVE_USERS_ENDPOINT } from '../../types/AnalyticsApi';
import { DataPoint, HandledData, TimeSeriesDataPoint } from '../../types/CompositeDataProvider';
import CompositeDataProvider from '../DataProviders/CompositeDataProvider';
import Legend from '../Legends/Legend';
import LineChartContainer from '../LineChart/LineChartContainer';
import ChartSectionContainer from '../Section/ChartSectionContainer';
import SectionChart from '../Section/SectionChart';
import SectionHeader from '../Section/SectionHeader';

interface DashboardRollingAUChartProps {
    countryCode?: string[] | null;
    from?: string | null;
    to?: string | null;
    companyId?: string[] | null;
    departmentId?: string[] | null;
}

const addToInterval = (intervals: Map<number, DataPoint[]>, date: number, key: string, value: number) => {
    if (!intervals.has(date)) {
        intervals.set(date, []);
    }

    intervals.get(date)?.push({
        key,
        value
    });
};

const dataMerger = (dataSets: HandledData[]) => {
    let mergedData: TimeSeriesDataPoint[] = [];
    let intervals = new Map<number, DataPoint[]>();

    for (let dataSet of dataSets) {
        if (!dataSet.data) {
            continue;
        }

        for (let data of dataSet.data) {
            addToInterval(intervals, new Date(Date.parse(data.key)).getTime(), dataSet.id, data.value);
        }
    }

    intervals.forEach((value, key) => {
        mergedData.push({
            key: new Date(key),
            value
        });
    });

    return mergedData;
};

const DashboardRollingAUChart: React.FC<DashboardRollingAUChartProps> = (props) => {
    return (
        <ChartSectionContainer>
            <SectionHeader>Active Users (Rolling)</SectionHeader>

            <Legend
                items={[
                    {
                        name: 'DAU',
                        color: '#5cefff'
                    },
                    {
                        name: 'WAU',
                        color: '#ffeda5'
                    },
                    {
                        name: 'MAU',
                        color: '#d9a5ff'
                    }
                ]}
            />

            <SectionChart>
                <CompositeDataProvider
                    dataFormat="TIME_SERIES"
                    sources={[
                        {
                            id: 'DAU',
                            src: GET_ACTIVE_USERS_ENDPOINT,
                            options: {
                                interval: 'd',
                                rolling: true
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'WAU',
                            src: GET_ACTIVE_USERS_ENDPOINT,
                            options: {
                                interval: 'w',
                                rolling: true
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'MAU',
                            src: GET_ACTIVE_USERS_ENDPOINT,
                            options: {
                                interval: 'M',
                                rolling: true
                            },
                            handler: (res: any) => res.data
                        }
                    ]}
                    merger={dataMerger}
                    options={{
                        ...props
                    }}
                    updateOnEventStrings={['USER_ONLINE']}
                    throttleMilliseconds={10000}
                >
                    <LineChartContainer
                        margin={{
                            top: 10,
                            right: 30,
                            left: 75,
                            bottom: 40
                        }}
                        tickValue={10}
                        tickFormat={'%-d/%m/%Y'}
                        tooltipDateFormat={'dddd d/mm/yyyy'}
                    />
                </CompositeDataProvider>
            </SectionChart>
        </ChartSectionContainer>
    );
};

export default DashboardRollingAUChart;
